<form #f="ngForm" class="wcm-erp modal-view" style="min-height: 200px;">
    <app-wcm-table #wcmTable
                   id="cato-subnet-list"
                   refreshSignal="cato-subnet-list-refresh"
                   urlUpdateSignal="cato-subnet-list-url-update"
                   [api]="catoSubnetApi"
                   [allowPreferences]="false"
                   [disabledColumns]="localDisabledColumns"
                   [disableFiltersDisplay]="true"
                   [disableUrlUpdate]="disableUrlUpdate"
                   [enableRowClick]="enableRowClick"
                   [filters]="localFilters"
                   [hideColumnsWheel]="true"
                   [hidePaginator]="false"
                   [hideTableFilters]="hideTableFilters"
                   (rowClick)="rowClick?.emit($event)"
                   (fetchCallback)="fetchCallback()">

        <ng-template appWcmHeaderTitle text="Subnets"></ng-template>
        <ng-template appWcmHeaderRight>
            <ng-container *hasPermissions="'Antoine:CatoSubnetAdmin'">
                <button *ngIf="!localDisabledButtons.create"
                        class="btn btn-default"
                        type="button"
                        (click)="addCatoSubnet()"
                        [disabled]="editionInProgress">
                    <i class="fa fa-plus"></i> Nouveau
                </button>
            </ng-container>
        </ng-template>

        <app-wcm-col field="name" header="Name" type="none" class="text-center" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <input name="name_{{ item.id }}"
                       class="form-control wcm-highlight-req"
                       [(ngModel)]="item.name"
                       [disabled]="!item.editable"
                       [required]="true" />
            </ng-template>
        </app-wcm-col>

        <app-wcm-col field="cato_id" header=" Cato ID" type="none" class="text-center" [preventSort]="true">
          <ng-template appWcmColBody let-item="item">
            <input name="subnet_{{ item.cato_id }}"
              class="form-control wcm-highlight-req"
              [(ngModel)]="item.cato_id"
              [disabled]="true"
            >
          </ng-template>
        </app-wcm-col>

        <app-wcm-col field="interface" header="Interface" type="none" class="text-center" [width]="150" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <input name="interface_{{ item.id }}"
                       class="form-control wcm-highlight-req"
                       [(ngModel)]="item.interface"
                       [disabled]="!item.editable"
                       [required]="true" />
            </ng-template>
        </app-wcm-col>

        <app-wcm-col field="range_type" header="Type" type="none" [width]="150" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <select class="form-control wcm-highlight-req"
                        name="range_type_{{ item.id }}"
                        [disabled]="!item.editable || item.cato_id"
                        [required]="true"
                        [(ngModel)]="item.range_type">
                    <option *ngFor="let option of rangeTypeOptions" [value]="option.key">
                        {{ option.value }}
                    </option>
                </select>
            </ng-template>
        </app-wcm-col>

        <app-wcm-col field="subnet" header="Subnet" type="none" class="text-center" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <input name="subnet_{{ item.id }}"
                       class="form-control wcm-highlight-req"
                       [(ngModel)]="item.subnet"
                       [disabled]="!item.editable"
                       [pattern]="ipWithMaskPattern"
                       [required]="true"
                       (ngModelChange)="checkNetworkContainsIp(item)" />
                <div class="error-message" *ngIf="f.controls.subnet?.errors?.pattern">
                  Le format de l'IP est incorrect.<br>Exemple de valeur attendue : 192.168.1.0/24
                </div>
                <div class="error-message" *ngIf="f?.controls['subnet_' + item.id]?.errors?.noNetworkAndIpOverlap">
                  Ce subnet ne contient pas l'adresse définie.
                </div>
            </ng-template>
        </app-wcm-col>

        <app-wcm-col field="address" header="Local IP" type="none" class="text-center" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
              <ng-container *ngIf="item.range_type !== CatoSubnetRangeTypeEnum.Routed">
                <input name="address_{{ item.id }}"
                       class="form-control wcm-highlight-req"
                       [(ngModel)]="item.address"
                       [readonly]="!item.editable"
                       [required]="true"
                       [pattern]="ipPattern"
                       (ngModelChange)="checkNetworkContainsIp(item)" />
                <div class="error-message" *ngIf="f.controls.address?.errors?.pattern">
                  Le format de l'IP est incorrect.<br>Exemple de valeur attendue : 192.168.1.1
                </div>
                <div class="error-message" *ngIf="f?.controls['address_' + item.id]?.errors?.noNetworkAndIpOverlap">
                  Cette adresse n'est pas dans le subnet défini.
                </div>
              </ng-container>
            </ng-template>
        </app-wcm-col>

        <app-wcm-col field="vlan" header="VLAN" type="none" class="text-center" [width]="100" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <ng-container *ngIf="item.range_type !== CatoSubnetRangeTypeEnum.Routed">
                    <input name="vlan_{{ item.id }}"
                           class="form-control wcm-highlight-req"
                           type="number"
                           min="0"
                           max="4096"
                           [required]="item.range_type === CatoSubnetRangeTypeEnum.Vlan"
                           [(ngModel)]="item.vlan"
                           [disabled]="!item.editable"
                           (ngModelChange)="checkVlanNumber(item)" />
                    <div class="error-message" *ngIf="item.invalidVlan">
                        La valeur doit être comprise entre 0 et 4096
                    </div>
                </ng-container>
            </ng-template>
        </app-wcm-col>

        <app-wcm-col field="gateway_address" header="Gateway" type="none" class="text-center" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <ng-container *ngIf="item.range_type === CatoSubnetRangeTypeEnum.Routed">
                    <input name="gateway_address_{{ item.id }}"
                           class="form-control wcm-highlight-req"
                           [(ngModel)]="item.gateway_address"
                           [readonly]="!item.editable"
                           [required]="true"
                           [pattern]="ipPattern"
                           (ngModelChange)="checkNetworkContainsIp(item)" />
                  <div class="error-message" *ngIf="f.controls.address?.errors?.pattern">
                    Le format de l'IP est incorrect.<br>Exemple de valeur attendue : 192.168.1.1
                  </div>
                    <div class="error-message" *ngIf="f?.controls['gateway_address_' + item.id]?.errors?.noNetworkAndIpOverlap">
                      Cette adresse n'est pas dans le subnet défini.
                    </div>
                </ng-container>
            </ng-template>
        </app-wcm-col>

        <app-wcm-col field="internet_only" header="Internet Only" type="none" class="text-center" [width]="80" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <p-checkbox name="internet_only_{{ item.id }}"
                            [(ngModel)]="item.internet_only"
                            [binary]="true"
                            [disabled]="!item.editable">
                </p-checkbox>
            </ng-template>
        </app-wcm-col>

        <app-wcm-col field="dhcp_type" header="DHCP Type" type="none" [width]="150" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <ng-container *ngIf="item.range_type !== CatoSubnetRangeTypeEnum.Routed">
                    <select name="dhcp_type_{{ item.id }}"
                            class="form-control wcm-highlight-req"
                            [disabled]="!item.editable"
                            [required]="true"
                            [(ngModel)]="item.dhcp_type"
                            (ngModelChange)="dhcpTypeChanged()">
                        <option *ngFor="let option of dhcpTypeOptions" [value]="option.key">
                            {{ option.value }}
                        </option>
                    </select>
                </ng-container>
            </ng-template>
        </app-wcm-col>

        <app-wcm-col field="relay_group" header="Relay Groupe" type="none" class="text-center" [width]="100" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <ng-container *ngIf="item.dhcp_type === CatoSubnetDhcpTypeEnum.Relay">
                    <input name="relay_group_{{ item.id }}"
                           class="form-control wcm-highlight-req"
                           [(ngModel)]="item.relay_group"
                           [disabled]="!item.editable"
                           [required]="true" />
                </ng-container>
            </ng-template>
        </app-wcm-col>

        <app-wcm-col field="range"  header="Range" type="none" class="text-center" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <ng-container *ngIf="item.dhcp_type === CatoSubnetDhcpTypeEnum.Range">
                    <div class="flex flex-column">
                        <input name="range_{{ item.id }}"
                               class="form-control wcm-highlight-req"
                               [(ngModel)]="item.range"
                               [readonly]="!item.editable"
                               [required]="true" />
                    </div>
                </ng-container>
            </ng-template>
        </app-wcm-col>

        <app-wcm-col header="Action" id="action" type="none" class="text-right" [width]="80" [preventSort]="true">
            <ng-template appWcmColBody let-item="item">
                <div class="action-btn-bar" *hasPermissions="'Antoine:CatoSubnetAdmin'">
                    <button class="btn btn-default btn-xs" title="Editer"
                            (click)="edit(item)" type="button"
                            *ngIf="!item.editable && !editionInProgress"
                            [disabled]="loadingItemAction || (item.cato_id && item.range_type !== CatoSubnetRangeTypeEnum.Native)">
                        <i class="fas fa-pencil-alt"></i>
                    </button>

                    <button *ngIf="!item.editable && !editionInProgress"
                            class="btn btn-default btn-xs"
                            title="Supprimer"
                            type="button"
                            (click)="confirmDelete(item)"
                            [disabled]="loadingItemAction || item.cato_id">
                        <i class="fa fa-trash-alt"></i>
                    </button>

                    <button class="btn btn-default btn-xs" title="Enregistrer"
                            (click)="save(item)" type="submit"
                            *ngIf="item.editable"
                            [disabled]="loadingItemAction || f.form.invalid || (item.cato_id && item.range_type !== CatoSubnetRangeTypeEnum.Native)">
                        <i class="fas fa-check"></i>
                    </button>

                    <button class="btn btn-default btn-xs" title="Annuler"
                            (click)="cancelEdit(item)" type="button"
                            *ngIf="item.editable" [disabled]="loadingItemAction || item.cato_id">
                        <i class="fas fa-undo"></i>
                    </button>
                </div>
            </ng-template>
        </app-wcm-col>

    </app-wcm-table>
</form>
